import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/FitText.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@storyblok/react/dist/rsc/live-editing.mjs");
